function dbSelector(state) {
    return state.seat_selection.orm;
}

export default dbSelector;
